 <template>
  <div id="divList" class="card" :loading="organizations.loading">
      <div class="card-header">
        <button type="button" class="btn btn-outline-danger btn-sm" @click=closeOrganizations>x</button>
        <b>&nbsp;{{ ccaa }} </b> - Nº de centros: {{ filteredOrganizations.length }}
      </div>
      <div v-if="filteredOrganizations.length > 0" >
        <ul class="list-group list-unstyled">
          <li class="list-group-item" v-for="{ center, prov, rownum } in filteredOrganizations" :key="rownum">
            {{ center }} - {{ prov }}
          </li>
        </ul>
      </div>
      <div  style="margin-top: 35%; margin-left: 45%;" v-else-if="filteredOrganizations.length < 1" >
        <p><b>SIN DATOS</b></p>
      </div>
  </div>
</template>

<script>
import useOrganizations from '@/composables/useOrganizations';
import { inject, onMounted, computed, ref } from "vue";
import { filter } from 'lodash';

export default {
  setup() {
    const {
      organizations,
      handleFetchOrganizations,
    } = useOrganizations();

    const emitter = inject("emitter");

    let ccaa = ref('');

    const filteredOrganizations = computed(() => {
      return ccaa.value ? filter(organizations.data, ['ccaa', ccaa.value]) : organizations.data;
    });

    const closeOrganizations = ()=> {
      document.getElementById('divList').style.display = 'none';
    }

    onMounted(async () => {
      handleFetchOrganizations(),
      document.getElementById('divList').style.display = 'none';
      emitter.on("ccaaClicked", (obj) => {
        ccaa.value = obj;
        document.getElementById('divList').style.display = 'block';
      })
    });

    return {
      organizations,
      filteredOrganizations,
      ccaa,
      closeOrganizations,
    };
  },
};
</script>

<style>

.list-group-item {
  background-color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
}

.list-group, .ant-table-placeholder {
  background-color: rgba(255, 255, 255, 0.5);
  height: 550px;
  overflow-y: scroll;
}


</style>
